@if (search) {
  <etn-address-picker
    [value]="value"
    [placeholder]="messages?.search || ''"
    [required]="required"
    (valueChange)="onAddressChanged($event)"
  ></etn-address-picker>
}
<div #mapContainer class="map-container"></div>
